














import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { Choice } from "@/types";
import CauseMeasureEdit from "@/components/biaggregate/causemeasure/CauseMeasureEdit.vue";
import {
  BiaggregateCauseMeasure,
  DefaultBiaggregateCauseMeasure,
} from "#/model/biaggregate";

@Component({
  components: {
    CauseMeasureEdit,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  /** 主因仮説/打ち手コメントマスタ */
  private causeMeasure: BiaggregateCauseMeasure =
    DefaultBiaggregateCauseMeasure();

  /** 指標種類選択肢 */
  private metricsTypes: Choice[] = [];

  /** 指標レベル選択肢 */
  private metricsLevels: Choice[] = [];

  created() {
    this.fetch();
  }

  /** 主因仮説/打ち手コメントマスタ取得 */
  private fetch() {
    const id = Number(this.$route.params.id);
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/causemeasure/get",
      { id: id },
      (res) => {
        this.causeMeasure = res.data.cause_measure;
        this.metricsTypes = res.data.metrics_types;
        this.metricsLevels = res.data.metrics_levels;
      }
    );
  }

  /** キャンセルボタン押下 */
  private cancel() {
    this.moveToListPage();
  }

  /** 保存ボタン押下 */
  private save() {
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/causemeasure/save",
      {
        cause_measure: this.causeMeasure,
      },
      () => {
        this.moveToListPage();
      }
    );
  }

  /** 削除ボタン押下 */
  private remove() {
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/causemeasure/delete",
      {
        cause_measure: this.causeMeasure,
      },
      () => {
        this.moveToListPage();
      }
    );
  }

  /** 一覧画面へ遷移 */
  private moveToListPage() {
    this.$router.push({ path: "/biaggregate/causemeasure/list" });
  }
}
